import { IModel, IAttribute, Collection } from '../base/annotation';
import { Metamodel } from '../base/model';
import { AzureKeyVaultLinkedService } from './azure-key-vault.linkedservice';
import { Owned } from '../base/named';
import { ParameterValue } from '../base/parameter-value';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: 'AzureKeyVaultSecret'
})
export class AzureKeyVault extends Owned {
    public static readonly MODEL: IModel;

    public static readonly SECRET_NAME: IAttribute;
    public static readonly SECRET_VERSION: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AKVLinedService,
        reference: true,
        type: AzureKeyVaultLinkedService.MODEL
    })
    public storageLinkedService?: AzureKeyVaultLinkedService;

    /**
     * Parameter value for referenced linked service.
     */
    @Metamodel.attribute({
        collection: Collection.Array,
        constraint: {
            required: false
        },
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters?: ParameterValue[];

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SecretName,
        association: 'SECRET_NAME',
        templatable: true
    })
    public secretName?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SecretVersion,
        association: 'SECRET_VERSION',
        templatable: true
    })
    public secretVersion?: string;
}
